__turbopack_context__.v({
  "container": "index-module-scss-module__GYWVXa__container",
  "heading": "index-module-scss-module__GYWVXa__heading",
  "intro": "index-module-scss-module__GYWVXa__intro",
  "question": "index-module-scss-module__GYWVXa__question",
  "questions": "index-module-scss-module__GYWVXa__questions",
});
